import { render } from "./Fehler404View.vue?vue&type=template&id=b7be5f5a&scoped=true"
import script from "./Fehler404View.vue?vue&type=script&lang=js"
export * from "./Fehler404View.vue?vue&type=script&lang=js"

import "./Fehler404View.vue?vue&type=style&index=0&id=b7be5f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7be5f5a"]])

export default __exports__